/**
 * Interface that Describes how {@link CustomerInfo} should look like.
 *
 * @export
 * @interface CustomerInfo
 */
export interface CustomerInfo {
  /**
   * This holds aggregate code.
   * @type {string}
   * @default null
   * @memberof CustomerInfo
   */
  aggcode?: string;

  /**
   * This holds Children schools.
   * @type {{ [key: number]: string }}
   * @default null
   * @memberof CustomerInfo
   */
  children?: { [key: number]: string };

  /**
   * This holds Available stats year.
   * @type { Array<string>}
   * @default null
   * @memberof CustomerInfo
   */
  counteryears?: Array<string>;

  /**
   * This holds loggined in customer id.
   * @type { string}
   * @default null
   * @memberof CustomerInfo
   */
  customerid: string;

  /**
   * This holds loggined in customer name.
   * @type {string}
   * @default null
   * @memberof CustomerInfo
   */
  customername: string;

  /**
   * This holds available products.
   * @type {Array<string>}
   * @default null
   * @memberof CustomerInfo
   */
  goproducts?: Array<string>;

  /**
   * This holds all groups.
   * @type {{ [key: string]: Array<string>}}
   * @default null
   * @memberof CustomerInfo
   */
  groupLists?: { [key: string]: Array<string> };

  /**
   * This holds available groups.
   * @type {Array<string>}
   * @default null
   * @memberof CustomerInfo
   */
  groups?: Array<string>;

  /**
   * This shows if a customer has child institutes.
   * @type {boolean}
   * @default false
   * @memberof CustomerInfo
   */
  haschildren?: boolean;

  /**
   * This shows if a school falls under any group.
   * @type {boolean}
   * @default false
   * @memberof CustomerInfo
   */
  hasgroups?: boolean;

  /**
   * This shows if child institutes exists
   * @type {boolean}
   * @default false
   * @memberof CustomerInfo
   */
  hasinstitutionalchildren?: boolean;

  /**
   *
   * @type {boolean}
   * @default false
   * @memberof CustomerInfo
   */
  hasmidtier?: boolean;

  /**
   * This holds all products
   * @type {Array<string>}
   * @default null
   * @memberof CustomerInfo
   */
  products?: Array<string>;

  /**
   * This holds all avaialable statistics date
   * @type {{ [key: string]: string }}
   * @default null
   * @memberof CustomerInfo
   */
  usagedates?: { [key: string]: string };
}

export interface APIResponse {
  result: any;
  resultcode: number;
}

export interface ProductsAPIResponse extends APIResponse {
  result: {
    products: { [key: string]: string };
  };
}

export interface CustomerAPIResponse extends APIResponse {
  result: CustomerInfo;
}

export interface SearchableDropdownValue {
  label: string;
  value: string;
  isSelected?: boolean;
}

export const getProductsFromAPIResponse = (
  response: ProductsAPIResponse,
): { [key: string]: string } | null => {
  return response && response.result && response.result.products ? response.result.products : null;
};

export const getCustomerInfoFromAPIResponse = (
  response: CustomerAPIResponse,
): CustomerInfo | null => {
  return response && response.result ? response.result : null;
};

export interface ReportChartsRequestProps {
  /**
   * It will hold the loggedin user name if provided
   */
  loggedInUserName?: string;

  /**
   * It will hold the provided product name
   */
  productName?: string;

  /**
   * It will hold the report type
   */
  reportType?: string;

  /**
   * It will hold the start date
   */
  startDate?: Date | string;

  /**
   * It will hold the end date
   */
  endDate?: Date | string;

  /**
   * It holds the loggedIn user Id
   */
  cuId?: string;

  /**
   * It will hold the selected products
   */
  product?: string[];

  /**
   * It will hold the selected products
   */
  products?: SearchableDropdownValue[];

  /**
   * It will holds the selected customers
   */
  customer?: string;

  /**
   * It will holds the key for report like session/document etc
   */

  valueKey?: string;

  /**
   * It will holds byProduct N or Y
   */

  byProduct?: string;

  /**
   * It will holds selected groups for group report
   */
  groups?: object | Array<String>;

  /**
   * It will hold output type
   */
  outputType?: 'Html' | 'Csv';
}

export interface IndividualSiteRequestProps {
  cuId?: string;
  reportType?: string;
  requestBody?: ReportChartsRequestProps;
}
